import axios from "@/utils/request.js";
import qs from "qs"
// 新增菜单 保存
const menuChange = (params) => axios({
  url: '/api/web-manager/live/menu/change',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 删除菜单
const menuDelete = (params) => axios({
  url: '/api/web-manager/live/menu/delete',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

// 开启关闭评论审核
const menuExamine= (params) => axios({
  url: '/api/web-manager/live/menu/examine',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 互动聊天审核状态选择
const menuExamineInteraction= (params) => axios({
  url: '/api/web-manager/live/menu/activityexamine',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

// 查询所有菜单
const menuQuery = (params) => axios.get('/api/web-manager/live/menu/query', {
  params
})

// 菜单排序
const menuSort= (params) => axios({
    url: '/api/web-manager/live/menu/sort',
    method: 'post',
    data:params
  })
  // 开启隐藏菜单
const menuStatus= (params) => axios({
    url: '/api/web-manager/live/menu/status',
    method: 'post',
    data: qs.stringify(params)
  })
export {
    menuChange,
  menuDelete,
  menuExamine,
  menuQuery,
  menuSort,
  menuStatus,
  menuExamineInteraction
}